import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import UserContext from "../context/UserContext";
import Cookies from "js-cookie";
import Spinner from "./Spinner";
import { toast } from "react-toastify";

function ProtectedRoute({ children }) {
  const { user, setUser } = useContext(UserContext);

  // Auth state hasn't been resolved from cookie yet — wait
  if (user.fetchingAuth) {
    return <Spinner />;
  }

  if (!user.isAuth) {
    return <Navigate to="/login" replace />;
  }

  if (user.isAuth && !user.userAgentType) {
    // Show spinner if we are authenticated but haven't fetched role yet
    return <Spinner />;
  }

  if (user.isAuth && user.userAgentType) {
    if (user.userAgentType !== "ADMIN" && user.userAgentType !== "SUPERADMIN") {
      Cookies.remove("accessToken");
      setUser({ isAuth: false });
      toast.error(
        "Access denied. This portal is for admin staff only. Please contact your administrator.",
        { position: "top-center", autoClose: 6000 }
      );
      return <Navigate to="/login" replace />;
    }
  }

  return children;
}

export default ProtectedRoute;
